import React from "react";

import { Box, Typography, Pagination } from "@mui/material";
import Button from "../common/Button/Button";
import useMediaQuery from "@mui/material/useMediaQuery";
import Swipe from "../common/GalleryComponent/Swipe";

function ListingPagePagination({ pagePrev, pageNext, page }) {
  const mobMatch = useMediaQuery("(max-width:600px)");
  return (
    <>
      {mobMatch ? (
        <Box
          sx={{
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
            justifyContent: "center",
          }}
        >
          <Box
            sx={{
              marginBottom: "16px",
              display: "flex",
              columnGap: "16px",
            }}
          >
            <Swipe direction="left" opacity={1} onClick={pagePrev} />
            <Button
              variant="contained"
              sx={{
                maxWidth: 32,
                maxHeight: 32,
                minWidth: 32,
                minHeight: 32,
                borderRadius: "50%",
                opacity: 1,
                backgroundColor: "text.primary",
                color: "white",
              }}
            >
              {page}
            </Button>
            <Swipe direction="right" opacity={1} onClick={pageNext} />
          </Box>
          <Typography
            variant="caption"
            fontWeight="400"
            fontSize="12px"
            lineHeight="16px"
            color="text.primary"
          >
            1-20 of 300+ Machinery
          </Typography>
        </Box>
      ) : (
        <Box
          sx={{
            display: "flex",
            width: "100%",
            alignItems: "center",
            flexDirection: "column",
          }}
        >
          <Pagination
            count={99}
            sx={{
              marginTop: "72px",
              marginBottom: "22px",
              "& .MuiPaginationItem-root": {
                color: "#1F1F1F",
                "&:hover": {
                  background: "#EBEBEB",
                },
              },
              "& .Mui-selected": {
                backgroundColor: "#1F1F1F !important",
                color: "#FFF",
                "&:hover": {
                  backgroundColor: "#1F1F1F !important",
                  color: "#FFF",
                },
              },
            }}
          />
          <Typography
            variant="caption"
            fontWeight="400"
            fontSize="12px"
            lineHeight="16px"
            color="text.primary"
          >
            1-20 of 300+ Machinery
          </Typography>
        </Box>
      )}
    </>
  );
}

export default ListingPagePagination;
